<template>
  <system-custom-notifications-step :overflow="false" :sidebar="false">
    <template v-slot:content>
      <div class="custom-notification__container">
        <h4 class="custom-notification__heading">Build your notification</h4>
        <div class="custom-notification__selection">
          <div class="custom-notification__option">
            <input id="option-nexmo" type="checkbox" name="nexmo" v-model="stateDataNexmo">
            <label for="option-nexmo">SMS</label>
          </div>
          <div class="custom-notification__option">
            <input id="option-onesignal" type="checkbox" name="onesignal" v-model="stateDataOnesignal">
            <label for="option-onesignal">Push Notification</label>
          </div>
          <div class="custom-notification__option">
            <input id="option-email" type="checkbox" name="email" v-model="stateDataEmail">
            <label for="option-email">Email</label>
          </div>
        </div>
        <div v-if="!$v.platformChosen" class="help-block text-center" >Please choose an option</div>
      </div>

      <div v-if="stateDataNexmo" class="custom-notification__form">
        <h2>SMS Options</h2>
        <textarea
          name="text"
          class="form-control"
          rows="2"
          ref="nexmo_message"
          maxlength="160"
          v-model="stateDataNexmoText"
          placeholder="Write your message here"/>
        <div>
          <small>{{ data.nexmo.text.length }} of 160 characters</small>
          <div v-if="!$v.stateDataNexmoText.required" class="help-block pull-right" >Message is required</div>
        </div>
      </div>

      <div v-if="stateDataOnesignal" class="custom-notification__form">
        <h2>Push Notification Options</h2>
        <h3>Push Notification Heading</h3>
        <textarea
          name="text"
          class="form-control"
          rows="2"
          ref="notification_heading"
          v-model="stateDataNotificationHeading"
          placeholder="Write your heading here"/>
        <div v-if="!$v.stateDataNotificationHeading.required" class="help-block" >Heading is required</div>
        <br/>
        <h3>Push Notification Content</h3>
        <textarea
          name="text"
          class="form-control"
          rows="2"
          ref="notification_heading"
          v-model="stateDataNotificationContent"
          placeholder="Write your message here"/>
        <div v-if="!$v.stateDataNotificationContent.required" class="help-block" >Content is required</div>
        <br/>
      </div>

      <div v-if="stateDataEmail" class="custom-notification__form">
        <h2>Email Options</h2>
        <h3>Email Subject</h3>
        <textarea
          name="text"
          class="form-control"
          rows="2"
          ref="email_heading"
          v-model="stateDataEmailHeading"
          :disabled="stateDataEmailSubjectSame && stateDataOnesignal"
          :placeholder="stateDataEmailSubjectSame && stateDataOnesignal ? stateDataNotificationHeading : 'Write your heading here'"
        />
        <div class="clearfix" >
          <div v-if="!$v.stateDataEmailHeading.required" class="help-block pull-right" >Subject is required</div>
          <div v-if="stateDataOnesignal" class="checkbox checkbox-primary">
            <input v-model="stateDataEmailSubjectSame" type="checkbox" :id="`checkbox-same-subject`" :value="true"/>
            <label :for="`checkbox-same-subject`">Same as push notification?</label>
          </div>
        </div>
        <h3>Email Content</h3>
        <redactor
          v-model="stateDataEmailContent"
          type="text"
          class="form-control"
          name="email_content"
          ref="email_content"
          rows="2"
          :disabled="stateDataEmailContentSame && stateDataOnesignal"
          :placeholder="stateDataEmailContentSame && stateDataOnesignal ? stateDataNotificationContent : 'Write your content here'"/>
        <div class="clearfix">
          <div v-if="!$v.stateDataEmailContent.required" class="help-block pull-right" >Content is required</div>
          <div v-if="stateDataOnesignal" class="checkbox checkbox-primary">
            <input v-model="stateDataEmailContentSame" type="checkbox" :id="`checkbox-same-content`" :value="true"/>
            <label :for="`checkbox-same-content`">Same as push notification?</label>
          </div>
        </div>
        <br/>
        <br/>
      </div>

      <div v-if="stateDataOnesignal || stateDataEmail">
        <div class="custom-notification__container">
          <div class="custom-notification__selection">
            <div class="custom-notification__option">
              <input id="option-url" type="checkbox" name="notification_url" v-model="stateDataNotificationUrl">
              <label for="option-url">Add URL Redirect</label>
            </div>
            <div class="custom-notification__option">
              <input id="option-response" type="checkbox" name="notification_response"
                     v-model="stateDataNotificationResponse">
              <label for="option-response">Collect Responses</label>
            </div>
            <div class="custom-notification__option">
              <input id="option-package" type="checkbox" name="notification_package"
                     v-model="stateDataNotificationPackage">
              <label for="option-package">Package Notification</label>
            </div>
          </div>
        </div>
        <br/>
        <div class="custom-notification__form">
          <div v-if="data.settings.package_notification">
            <h3>Selected Package</h3>
            <selectize
              class="selectize selectize-single form-control"
              name="tag_type"
              :options="packageList"
              v-model="stateDataNotificationSelectedPackage"
              :disable-delete="true">
            </selectize>
            <div v-if="!$v.stateDataNotificationSelectedPackage.required" class="help-block" >Package is required</div>

          </div>
          <div v-if="data.settings.link_notification">
            <h3>Push Notification Link</h3>
            <textarea
              name="text"
              class="form-control"
              rows="2"
              ref="notification_heading"
              v-model="stateDataNotificationLink"
              placeholder="Write your link here, use {talent_id} or {talent_slug} to add a talent id or name to the link"/>
            <div v-if="!$v.stateDataNotificationLink.required" class="help-block pull-right" >Link is required</div>
          </div>
          <div v-if="data.settings.response_notification">
            <h2>
              Action Buttons
              <a v-on:click="addActionButton"
                 data-backdrop="static"
                 :class="checkCanAddAction">
                <i class="fa fa-plus"></i>
                <template>Add Button</template>
              </a>
            </h2>
            <div class="description"> Note: A dismiss/cancel button saying 'Sorry, Not Interested' gets automatically
              added to the notification and doesn't need to be added.
            </div>
            <br/>
            <div class="dashboard-block">
              <ul
                v-for="(suboption, index) in data.settings.button_items"
                :key="index"
                class="item-detail">
                <system-custom-notifications-response-list-item
                  :index="index" :extra-field="index>0" :validation="$v.stateDataButtonItems.$each[index]"
                />
              </ul>
              <div id="bottom"></div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:cta>
      <button class="btn btn-primary pull-right" type="button" :disabled="$v.$invalid" @submit.prevent v-on:click="nextPage">Continue <i class="fa fa-chevron-right"></i></button>
    </template>
  </system-custom-notifications-step>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { stateMapper } from 'mixins/notifications'
import SystemCustomNotificationsStep from './SystemCustomNotificationsStep'
import SystemCustomNotificationsResponseListItem from './SystemCustomNotificationsResponseListItem'
import Selectize from '../ext/codium/CodiumSelectize'
import { requiredIf, required } from 'vuelidate/lib/validators'
import Redactor from 'codium-redactor'

export default {
  components: {
    SystemCustomNotificationsResponseListItem,
    SystemCustomNotificationsStep,
    Selectize,
    Redactor
  },

  mixins: [stateMapper],

  data () {
    return {
      packageList: []
    }
  },

  computed: {
    ...mapState('notification', ['data']),
    ...mapState('tags', ['packages']),

    stateDataButtonItems () {
      if (!this.data.settings.response_notification) {
        return []
      }

      return this.data.settings.button_items || []
    },

    checkCanAddAction () {
      return this.data.settings.button_items.length < 3
        ? 'btn btn-sm pull-right'
        : 'btn btn-sm pull-right disabled'
    }
  },

  validations: {
    platformChosen: function () { return this.stateDataNexmo || this.stateDataOnesignal || this.stateDataEmail },
    stateDataNexmoText: {
      required: requiredIf(model => model.stateDataNexmo)
    },
    stateDataNotificationHeading: {
      required: requiredIf(model => model.stateDataOnesignal)
    },
    stateDataNotificationContent: {
      required: requiredIf(model => model.stateDataOnesignal)
    },
    stateDataEmailHeading: {
      required: requiredIf(model => model.stateDataEmail && !model.stateDataEmailSubjectSame)
    },
    stateDataEmailContent: {
      required: requiredIf(model => model.stateDataEmail && !model.stateDataEmailContentSame)
    },
    stateDataNotificationLink: {
      required: requiredIf(model => model.data.settings.link_notification)
    },
    stateDataNotificationSelectedPackage: {
      required: requiredIf(model => model.data.settings.package_notification)
    },
    stateDataButtonItems: {
      $each: {
        button_text: {
          required
        }
      }
    }
  },

  methods: {
    ...mapActions('notification', ['nextPage', 'addActionButton']),
    ...mapActions('tags', ['getPackages'])
  },

  created () {
    this.getPackages().then(() => {
      this.packageList = this.packages.map((object) => {
        return { id: object.id, text: object.name }
      })
    })
  }
}
</script>
